import { ChevronDownIcon } from '@heroicons/react/24/outline';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './Dropdown.tsx';

type RegionType = 'eu' | 'us' | 'self-hosted';

export function RegionPicker({
  region,
  onRegionSelect,
}: {
  region: RegionType;
  onRegionSelect?: (region: RegionType) => void;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="data-[state=open]:bg-bg-secondary group inline-flex items-center gap-1 self-center rounded-md py-1 text-ls-black outline-none">
        <span className="flex items-center gap-4 text-sm">
          <span>Data Region</span>
          {region === 'eu' && <span>🇪🇺 EU</span>}
          {region === 'us' && <span>🇺🇸 US</span>}
          {region === 'self-hosted' && <span>🏳️ Self-hosted</span>}
        </span>
        <ChevronDownIcon className="h-4 w-4 group-data-[state=open]:rotate-180" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem className="flex items-center gap-2" asChild>
          <a
            href={
              region !== 'us' && onRegionSelect == null
                ? 'https://smith.langchain.com'
                : undefined
            }
            onClick={(e) => {
              if (onRegionSelect != null) {
                e.stopPropagation();
                if (region != 'us') onRegionSelect('us');
              }
            }}
          >
            <span>🇺🇸</span>
            <span>US</span>
            <span className="text-tertiary">Central</span>
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem className="flex items-center gap-2" asChild>
          <a
            href={
              region !== 'eu' && onRegionSelect == null
                ? 'https://eu.smith.langchain.com'
                : undefined
            }
            onClick={(e) => {
              if (onRegionSelect != null) {
                e.stopPropagation();
                if (region != 'eu') onRegionSelect('eu');
              }
            }}
          >
            <span>🇪🇺</span>
            <span>EU</span>
            <span className="text-tertiary">West</span>
          </a>
        </DropdownMenuItem>
        {onRegionSelect && (
          <DropdownMenuItem className="flex items-center gap-2" asChild>
            <a
              onClick={(e) => {
                if (onRegionSelect != null) {
                  e.stopPropagation();
                  if (region != 'self-hosted') onRegionSelect('self-hosted');
                }
              }}
            >
              <span>🏳️</span>
              <span>Self-hosted</span>
            </a>
          </DropdownMenuItem>
        )}

        <DropdownMenuSeparator />

        <a
          href="https://docs.langchain.com/langsmith/cloud-architecture-and-scalability#architecture"
          rel="noreferrer noopener"
          target="_blank"
          className="block px-2 py-1 text-sm text-brand-green-400"
          onClick={(e) => e.stopPropagation()}
        >
          Learn more about regions
        </a>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
